import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import "./../../assets/css/TravelDestinations.css";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../component/commanfile";
import { GeoAlt, ArrowRightCircleFill } from "react-bootstrap-icons";

import { Container, Row, Col, Badge } from "react-bootstrap";

const TravelDestinations = ({ packages }) => {
  const navigate = useNavigate();

  return (
    <section
    style={{
    background: "linear-gradient(180deg, #eaf3ff 0%, #ffffff 100%)",
    padding: "60px 0"
  }}
    >
      <div className="section-header">
        <h2>Discover Dream Destinations</h2>
        <p>
          Explore our curated selection of all-inclusive tours to breathtaking
          destinations around the world
        </p>
      </div>

      {/* <Swiper
        modules={[Navigation, Autoplay]}
        navigation={true}
        loop={true}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        slidesPerView={3}
        spaceBetween={30}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 20 },
          768: { slidesPerView: 3, spaceBetween: 30 },
        }}
        className="travel-swiper"
      >
        {packages.map((dest, idx) => (
          <SwiperSlide key={idx}>
            <div className="travel-card">
              <div
                className="travel-card-image"
                style={{ backgroundImage:`url(${BASE_URL}/api/image?file=${ (dest.thumbnail?.substring(1))})` }}
              >
               <div style={{
                position:"absolute",
                top:"25px",
                right:"30px",
                padding:"5px 10px",
                backgroundColor:"rgba(255,255,255,0.8)",
                borderRadius:"5px",
                fontSize:"14px",
                fontWeight:"bold",
                color:"#333"
               }}>
                {dest.type == "fit" ? "Private" : "Group"}
                </div> 
              </div>

              <div className="travel-overlay">
                <div style={{
                  display:"flex",
                  justifyContent:"space-between"
                }}>

                <div className="region-badge">
                  <span>{dest?.sector_name}</span>
                </div>
                  <div className="card-actions">
                  <div
                    className="explore-btn"
                    onClick={() =>
                      navigate(`/tour-details/${dest.type == "fit" ? "fit-" : ""}${dest.id}`, { state: { tourId: dest.id } })
                    }
                  >
                    Explore Now
                  </div>
                </div>
                </div>

                <h4

                >{dest.name}</h4>
         

                <div className="details">
                  <i className="fas fa-calendar-alt"></i>
                  &nbsp;{dest.type == "fit" ? dest.itinerary.length : dest.duration} Days {dest.type == "fit" ? dest.itinerary.length - 1 : dest.duration - 1} Nights&nbsp;.&nbsp;
                </div>
                <div className="terms">*Terms & Conditions Apply</div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}
    {/* <div className="tour-cards-section"> */}
      <Container>

          <Row className="g-4">
          {packages?.map((dest, idx) => (
            <Col key={dest.id} xs={12} sm={6} lg={3}
              onClick={() =>
                navigate(`/tour-details/${dest.type == "fit" ? "fit-" : ""}${dest.id}`, { state: { tourId: dest.id } })
              }
            >
              <div className="tour-cards">
                <div className="tour-card-img-wrapper">
                 <img
                    src={ `${BASE_URL}${ (dest.thumbnail?.substring(1))}`}
  alt={dest.name}
  className="tour-card-img"
 
/>
                  <div className="tour-card-gradient" />
                  
                  {/* Text Overlay on Image */}
                  <div className="overlay-info">
                    <h5>{dest.name}</h5>
                 
                  </div>
                </div>

                <div className="tour-card-body">
                  <div className="tour-guests">
                    {dest.description || "Explore our exclusive packages for this region."}
                  </div>
                  <span className="view-link">
                    View All <ArrowRightCircleFill className="ms-1" />
                  </span>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
      {/* </div> */}

      {/* <div className="view-all-container">
        <a href="#" className="view-all-btn">
          View All Destinations <i className="fas fa-arrow-right ml-2"></i>
        </a>
      </div> */}
    </section>
  );
};

export default TravelDestinations;
